(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.faynFlavorPickerReady) return;
    window.faynFlavorPickerReady = true;
    document.documentElement.classList.add('flavor-picker-ready');

    const setOpen = (root, open) => {
      const panel = root.querySelector('.flavor-picker__panel');
      const trigger = root.querySelector('.flavor-picker__trigger');
      if (!panel || !trigger) return;

      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      root.toggleAttribute('data-open', open);

      if (open) {
        const current = panel.querySelector('.is-selected');
        if (current) panel.scrollTop = current.offsetTop - (panel.clientHeight - current.offsetHeight) / 2;
      }
    };

    // Ist die aktuelle Kombination (z. B. Box) bei der neuen Sorte nicht lieferbar, wird eine lieferbare
    // Kombination (z. B. Einzelriegel) der anderen Optionen vorgewaehlt, bevor die Auswahl abgeschickt wird.
    const selectAvailableCombination = (root, combos) => {
      const picker = root.closest('variant-picker');
      if (!picker || !combos) return;

      const position = Number(root.dataset.optionPosition);
      const list = combos.split(';').map((combo) => combo.split('|'));
      const checked = Array.from(picker.querySelectorAll('fieldset input[type="radio"][data-input-id]:checked')).map((radio) => ({
        radio,
        index: Number(radio.dataset.inputId?.split('-')[0]) - 1,
      }));

      if (list.some((combo) => checked.every(({ radio, index }) => combo[index] === radio.value))) return;

      const target = list[0];
      picker.querySelectorAll('fieldset input[type="radio"][data-input-id]').forEach((radio) => {
        const index = Number(radio.dataset.inputId?.split('-')[0]) - 1;
        if (index + 1 !== position && target[index] === radio.value) radio.checked = true;
      });
    };

    const closeAll = (except) => {
      document.querySelectorAll('[data-flavor-picker][data-open]').forEach((root) => {
        if (root !== except) setOpen(root, false);
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const trigger = target.closest('.flavor-picker__trigger');
      if (trigger) {
        const root = trigger.closest('[data-flavor-picker]');
        if (!root) return;
        closeAll(root);
        setOpen(root, !root.hasAttribute('data-open'));
        return;
      }

      const row = target.closest('.flavor-picker__row');
      if (row) {
        const root = row.closest('[data-flavor-picker]');
        const select = root?.querySelector('select.variant-option__select');
        const option = select && Array.from(select.options).find((item) => item.value === row.dataset.flavorValue);
        if (!root || !select || !option) return;

        setOpen(root, false);
        selectAvailableCombination(root, row.dataset.availableCombos);
        if (select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      closeAll(target.closest('[data-flavor-picker]'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('[data-flavor-picker][data-open]');
      if (!open) return;
      setOpen(open, false);
      open.querySelector('.flavor-picker__trigger')?.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
